// extracted by mini-css-extract-plugin
var _1 = "Activities_wrapper__ZV3U+";
export { _1 as "wrapper" }
